
export class RawCommandEntry
{
    constructor(public Label: string, public Command: string) { }
}
